import { LoginForm } from "./login-form";
import { AppPage } from "@/types/navigation";

interface LoginProps {
  onNavigate: (page: AppPage) => void;
}

export default function Login({ onNavigate }: LoginProps) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <LoginForm onNavigate={onNavigate} />
      </div>
    </div>
  );
} 